var gql = require("@apollo/client").gql;

const SEARCH_HOUSE_QUERY_V5 = gql`
	query SEARCH_HOUSE_QUERY_V5($query: String, $street_id: Int!) {
		searchHousesV5(street_id: $street_id, query: $query, with_tariffs: 1) {
			data {
				highlight {
					full
				}
				data {
					id
					region_id
					district_id
					street_id
					house
					building
					construction
					full
					url
					district_name
					street_name
					street_type
				}
			}
		}
	}
`;
export default SEARCH_HOUSE_QUERY_V5;
